var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-styles" },
    [
      _c("div", { staticClass: "c-s-t" }, [_vm._v("图表设置")]),
      _vm._v(" "),
      _vm.selectedWidget.type == "listTable" ||
      _vm.selectedWidget.type == "pivotTable"
        ? [
            _vm.selectedWidget.type == "listTable"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "最大展示条数" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 1, max: 999 },
                      model: {
                        value: _vm.optionModel.setChartConf.pageSize,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.optionModel.setChartConf,
                            "pageSize",
                            $$v
                          )
                        },
                        expression: "optionModel.setChartConf.pageSize",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "汇总行显示" } },
              [
                _c("el-switch", {
                  model: {
                    value: _vm.optionModel.setChartConf.showSummary,
                    callback: function ($$v) {
                      _vm.$set(_vm.optionModel.setChartConf, "showSummary", $$v)
                    },
                    expression: "optionModel.setChartConf.showSummary",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "汇总列显示" } },
              [
                _c("el-switch", {
                  model: {
                    value: _vm.optionModel.setChartConf.showSumcol,
                    callback: function ($$v) {
                      _vm.$set(_vm.optionModel.setChartConf, "showSumcol", $$v)
                    },
                    expression: "optionModel.setChartConf.showSumcol",
                  },
                }),
              ],
              1
            ),
          ]
        : [
            _c(
              "el-form-item",
              { attrs: { label: "数值显示" } },
              [
                _c("el-switch", {
                  model: {
                    value: _vm.optionModel.setChartConf.numShow,
                    callback: function ($$v) {
                      _vm.$set(_vm.optionModel.setChartConf, "numShow", $$v)
                    },
                    expression: "optionModel.setChartConf.numShow",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "图例显示" } },
              [
                _c("el-switch", {
                  attrs: {
                    disabled:
                      _vm.selectedWidget.type == "progressbar" &&
                      _vm.optionModel.chartStyle != 1,
                  },
                  model: {
                    value: _vm.optionModel.setChartConf.chartShow,
                    callback: function ($$v) {
                      _vm.$set(_vm.optionModel.setChartConf, "chartShow", $$v)
                    },
                    expression: "optionModel.setChartConf.chartShow",
                  },
                }),
              ],
              1
            ),
          ],
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "使用全部数据" } },
        [
          _c("el-switch", {
            model: {
              value: _vm.optionModel.setChartConf.useAllData,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel.setChartConf, "useAllData", $$v)
              },
              expression: "optionModel.setChartConf.useAllData",
            },
          }),
          _vm._v(" "),
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "dark",
                content: "不启用则只能查看登录用户权限内的数据",
                placement: "top",
              },
            },
            [
              _c(
                "span",
                { staticClass: "question-icon" },
                [
                  _c("el-icon", {
                    staticClass: "el-icon-warning-outline",
                    attrs: { size: "16" },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }